export const REFERRAL_STATUS = {
  INVITED: 'invited',
  DECLINED: 'declined',
};
